import React from 'react';
import { Grid, Box, Typography, IconButton, Button } from '@mui/material';
import { grey } from '@mui/material/colors';
import CommonQuillEditor from 'common/editor';
import DeleteIcon from 'common/customIcons/delete';

const FAQFormList = ({ faqs, onChange, onRemove, onAdd }) => {
  return (
    <>
      <Grid container>
        {faqs?.length > 0 && (
          faqs.map((faq, idx) => (
            <Grid key={idx} item xs={12} sm={12} lg={12} mb={3} className="faq-sec-rep">
              <Grid container alignItems="flex-start">
                <Grid item xs={12} lg={12} md={12}>
                  <Box display="flex" justifyContent="center" alignItems={"flex-start"}>
                    <Box width={"100%"}>
                      <Typography variant="body2" fontWeight="medium" color={grey[600]} mb={1}>
                        Question
                      </Typography>
                      <CommonQuillEditor
                        allowHeading={false}
                        allowImage={false}
                        value={faq?.question || ""}
                        onChange={(value) => onChange(value, "question", idx)}
                      />
                    </Box>
                    <Box className="remove-btn">
                      <IconButton onClick={() => onRemove(idx)}>
                        <DeleteIcon width="16px" height="16px" />
                      </IconButton>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
              <Grid container alignItems="flex-start" mt={2}>
                <Grid item xs={12} lg={12} md={12}>
                  <Typography variant="body2" fontWeight="medium" color={grey[600]} mb={1}>
                    Answer
                  </Typography>
                  <CommonQuillEditor
                    allowHeading={false}
                    allowImage={false}
                    value={faq?.answer || ""}
                    onChange={(value) => onChange(value, "answer", idx)}
                  />
                </Grid>
              </Grid>
            </Grid>
          ))
        )}
      </Grid>
      
      <Box display="flex" justifyContent="space-between" alignItems={"center"} my={1}>
        <Button sx={{ minWidth: "160px" }} type="button" onClick={onAdd} variant="contained" color="primary">
          Add FAQ
        </Button>
      </Box>
    </>
  );
};

export default FAQFormList